import { connect } from 'react-redux'
import { pathOr } from 'ramda'
import { format, isAfter } from 'date-fns'
import { ChatBot } from '../../components'
import { chatbotSelectors } from 'modules/ui/ChatBot'
import { portfolioApiSelectors } from 'modules/api/portfolio'
import { get10thOfLeaseEndMonth } from 'modules/portfolios/components/PortfolioWizard/PortfolioRenewalForm/portfolioRenewalFormUtils'

const getDescription = (state: any): string => {
  const currentPortfolioId = chatbotSelectors.getCurrentPortfolioId(state)
  const renewal = portfolioApiSelectors.getPortfolioFieldById(state)(currentPortfolioId, ['renewal'])

  if (renewal) {
    return 'A renewal has been scheduled for this lease. You can update the details or cancel the renewal below.'
  }

  const termsDialog = chatbotSelectors.getLeaseTermDialog(state)
  const leaseEndDate = pathOr(format(new Date(), 'yyyy-MM-dd'), ['term', 'endDate'], termsDialog)
  const isImmediate = isAfter(new Date(), get10thOfLeaseEndMonth(new Date(leaseEndDate)))

  return isImmediate
    ? 'Enter the details for the new lease term. The renewal will be confirmed immediately, updating rental amount, commission and invoice templates now.'
    : 'Enter the details for the new lease term. Changes to rental amount, commission and invoice templates will take effect on the 10th of the last lease month.'
}

const mapStateToProps = (state, { push }: any) => ({
  actions: [],
  title: 'Renewal',
  description: getDescription(state),
})

const mapDisptchToProps = (dispatch: any) => ({
  actionClickHandler: (action: any) => dispatch(action()),
})

export default connect(mapStateToProps, mapDisptchToProps)(ChatBot)
